import * as React from 'react';
import { useState } from 'react';
import { Button, Empty, Spin, Switch } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Modal } from 'components/modal/modal';
import { WorldCupTeam } from 'core/domain';
import { getAllTeams, updateTeamIsWin } from 'core/repositories/world-cup-teams';
import './world-cup-teams.scss';
import { SERVER_URL } from '../../../../core/constants/constants';

export const WorldCupTeams: React.FC = () => {
    const [teams, setTeams] = useState<WorldCupTeam[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [confirmModal, setConfirmModal] = useState<boolean>(false);
    const [selectedTeam, setSelectedTeam] = useState<WorldCupTeam | null>(null);
    const [pendingIsWin, setPendingIsWin] = useState<boolean>(false);

    React.useEffect(() => {
        getAllTeams(setLoading, setTeams);
    }, []);

    const handleToggleClick = (team: WorldCupTeam, newValue: boolean) => {
        setSelectedTeam(team);
        setPendingIsWin(newValue);
        setConfirmModal(true);
    };

    const handleConfirm = () => {
        if (!selectedTeam) return;
        updateTeamIsWin(setLoading, selectedTeam.id, pendingIsWin, () => {
            setTeams((prev) =>
                prev.map((t) => (t.id === selectedTeam.id ? { ...t, isWin: pendingIsWin } : t)),
            );
            setConfirmModal(false);
            setSelectedTeam(null);
        });
    };

    const handleCancel = () => {
        setConfirmModal(false);
        setSelectedTeam(null);
    };

    const renderFlag = (team: WorldCupTeam) => {
        const isUrl = team.flag && (team.flag.startsWith('http') || team.flag.startsWith('/'));
        return isUrl ? (
            <img src={SERVER_URL + team.flag} alt={team.name} className="team-flag-img" />
        ) : (
            <span className="team-flag-emoji">{team.flag}</span>
        );
    };

    return (
        <Page className="pmx-world-cup-teams">
            <Card title="مدیریت تیم های برنده جام جهانی ۲۴ ساعت گذشته" blur={loading}>
                <Spin spinning={loading}>
                    {teams.length === 0 && !loading ? (
                        <Empty description="تیمی یافت نشد" />
                    ) : (
                        <div className="teams-grid">
                            {teams.map((team) => (
                                <div
                                    key={team.id}
                                    className={`team-card ${team.isWin ? 'is-winner' : ''}`}
                                >
                                    {team.isWin && (
                                        <div className="winner-ribbon">
                                            <TrophyOutlined /> برنده
                                        </div>
                                    )}
                                    <div className="team-flag">{renderFlag(team)}</div>
                                    <div className="team-name">{team.name}</div>
                                    <span className={`win-badge ${team.isWin ? 'winner' : 'not-winner'}`}>
                                        {team.isWin ? 'برنده' : 'غیر برنده'}
                                    </span>
                                    <Switch
                                        className="team-switch"
                                        checked={team.isWin}
                                        checkedChildren="برنده"
                                        unCheckedChildren="غیر برنده"
                                        onChange={(checked) => handleToggleClick(team, checked)}
                                        disabled={loading}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </Spin>
            </Card>

            <Modal
                title="تایید تغییر وضعیت"
                isOpen={confirmModal}
                setIsOpen={setConfirmModal}
                onClose={handleCancel}
                className="world-cup-confirm-modal"
            >
                <div className="confirm-modal-body">
                    <p className="confirm-text">
                        آیا مطمئن هستید که می‌خواهید وضعیت تیم{' '}
                        <strong>«{selectedTeam?.name}»</strong> را تغییر دهید؟
                    </p>
                    <p className="confirm-new-status">
                        وضعیت جدید:{' '}
                        <span className={`win-badge ${pendingIsWin ? 'winner' : 'not-winner'}`}>
                            {pendingIsWin ? 'برنده' : 'غیر برنده'}
                        </span>
                    </p>
                    <div className="confirm-actions">
                        <Button onClick={handleCancel}>انصراف</Button>
                        <Button type="primary" loading={loading} onClick={handleConfirm}>
                            تایید
                        </Button>
                    </div>
                </div>
            </Modal>
        </Page>
    );
};
